// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__17R7c","left":"StickyBox_left__3o1Me","right":"StickyBox_right__3waxy"};